import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { Code, ArrowForward } from '@mui/icons-material';
import { Link } from 'react-router-dom';

const ApiReference = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Rediriger vers la documentation après 3 secondes
        const timer = setTimeout(() => {
            navigate('/documentation', { replace: true });
        }, 3000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <>
            <Helmet>
                <title>Référence API - Netikash Developer Portal</title>
                <meta name="description" content="Référence complète de l'API Netikash : endpoints, paramètres, réponses et exemples de code." />
                <link rel="canonical" href="https://dev.netikash.com/api-reference" />
            </Helmet>
            <div className="min-h-screen bg-gray-50 dark:bg-slate-950 dark:text-slate-100 pt-16 flex items-center justify-center">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
                    <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-12">
                        <div className="w-20 h-20 bg-amber-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                            <Code className="text-amber-600 text-4xl" />
                        </div>
                        <h1 className="text-4xl font-bold text-gray-900 mb-4">Référence API</h1>
                        <p className="text-xl text-gray-700 mb-8">
                            Vous êtes redirigé vers la documentation complète de l'API Netikash...
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <Link
                                to="/documentation"
                                className="inline-flex items-center justify-center space-x-2 px-8 py-3 bg-gradient-to-r from-amber-500 to-yellow-600 text-white rounded-lg font-medium hover:from-amber-600 hover:to-yellow-700 transition-all"
                            >
                                <span>Aller à la documentation</span>
                                <ArrowForward />
                            </Link>
                            <Link
                                to="/examples"
                                className="inline-flex items-center justify-center px-8 py-3 bg-white border border-amber-300 text-amber-700 rounded-lg font-medium hover:bg-amber-50 transition-all"
                            >
                                Voir les exemples
                            </Link>
                        </div>
                        <div className="mt-8 text-sm text-gray-500">
                            Redirection automatique dans 3 secondes...
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="mt-12 grid md:grid-cols-3 gap-6">
                        <Link
                            to="/documentation?section=authorization"
                            className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-all text-left"
                        >
                            <h3 className="font-semibold text-gray-900 mb-2">Authentification</h3>
                            <p className="text-sm text-gray-600">OAuth2, tokens, clés API</p>
                        </Link>
                        <Link
                            to="/documentation?section=payment-request"
                            className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-all text-left"
                        >
                            <h3 className="font-semibold text-gray-900 mb-2">Paiements</h3>
                            <p className="text-sm text-gray-600">Créer et vérifier des paiements</p>
                        </Link>
                        <Link
                            to="/documentation?section=webhooks"
                            className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-all text-left"
                        >
                            <h3 className="font-semibold text-gray-900 mb-2">Webhooks</h3>
                            <p className="text-sm text-gray-600">Notifications en temps réel</p>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ApiReference;